import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'EnumToSelectButton',
  props: {
    modelValue: {
      type: [String, Number],
      required: true,
    },
    enum: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  watch: {
    selectValue: function (newValue) {
      this.$emit('update:modelValue', newValue);
    },
  },
})
export default class EnumToSelectButton extends Vue {
  enum!: Object;
  modelValue!: string | number;

  selectValue: string | number | null = null;

  get selectOptions() {
    return Object.values(this.enum)
      .filter(
        (value: string | number) =>
          typeof value !== 'number' && value.toLowerCase() !== 'none'
      )
      .map((value: keyof Object) => ({
        value: this.enum[value],
        label: this.$t(`AppResource.${value}`),
      }));
  }

  created() {
    this.selectValue = this.modelValue;
  }
}
